import { render } from "./ContractItemV3.vue?vue&type=template&id=22452f38&scoped=true"
import script from "./ContractItemV3.vue?vue&type=script&lang=js"
export * from "./ContractItemV3.vue?vue&type=script&lang=js"

import "./ContractItemV3.vue?vue&type=style&index=0&id=22452f38&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22452f38"]])

export default __exports__